var map = {
	"./background_loging.jpg": "0f26",
	"./background_person.png": "88b4",
	"./coins/available.png": "60dc",
	"./coins/galaxi-tab.png": "8d19",
	"./coins/locked.png": "8c01",
	"./coins/selected.png": "b0d4",
	"./flags/1x1/en.svg": "9372",
	"./flags/1x1/es.svg": "f497",
	"./illustrations/posting_photo.svg": "3174",
	"./logo-default.png": "c801",
	"./logo-default_old.png": "485b",
	"./logo-icon.png": "0585",
	"./logo-white.png": "39cc",
	"./logo-white2.png": "7c55",
	"./logo.svg": "1ae4",
	"./purposes/cloud.png": "0289",
	"./purposes/mujer_up.png": "3beb",
	"./purposes/recognition-create-help.png": "3ece",
	"./purposes/vote_bronze.png": "a835",
	"./purposes/vote_gold.png": "b9d8",
	"./purposes/vote_platinum.png": "261e",
	"./purposes/vote_silver.png": "e4a0",
	"./svg/error.svg": "cf30",
	"./svg/microsoft_logo.svg": "567d",
	"./svg/warning.svg": "c026",
	"./winners/nominated.jpg": "cec6",
	"./winners/prize_cup.gif": "23bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";